const customCache = new Set();
/**
 * 判断 给定的 scriptUrl 是否是有效的 url，且没有加载过
 * @param scriptUrl
 * @returns
 */
function isValidCustomScriptUrl(scriptUrl) {
    return Boolean(typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl));
}
/**
 * 根据 <script> 标签加载外网 iconfont
 * @param scriptUrls
 * @param index
 */
function createScriptUrlElements(scriptUrls, index = 0) {
    const currentScriptUrl = scriptUrls[index];
    if (isValidCustomScriptUrl(currentScriptUrl)) {
        const script = document.createElement('script');
        script.setAttribute('src', currentScriptUrl);
        script.setAttribute('data-namespace', currentScriptUrl);
        if (scriptUrls.length > index + 1) {
            script.onload = () => {
                createScriptUrlElements(scriptUrls, index + 1);
            };
            script.onerror = () => {
                createScriptUrlElements(scriptUrls, index + 1);
            };
        }
        customCache.add(currentScriptUrl);
        document.body.appendChild(script);
    }
}
/**
 * 加载图标库
 * 1. 从 iconfont.cn 提供的链接进行图标加载
 * 2. 从 本地项目 自己动态 import()
 * @param scriptUrl
 */
function loadIcons(scriptUrl) {
    /**
     * 通过 import([url]) 动态导入 本地的 iconfont 脚本
     */
    if (typeof scriptUrl === 'function') {
        return scriptUrl();
    }
    /**
     * DOM API required.
     * Make sure in browser environment.
     * The Custom Icon will create a <script/>
     * that loads SVG symbols and insert the SVG Element into the document body.
     */
    if (scriptUrl &&
        typeof document !== 'undefined' &&
        typeof window !== 'undefined' &&
        typeof document.createElement === 'function') {
        if (Array.isArray(scriptUrl)) {
            // 因为iconfont资源会把svg插入before，所以前加载相同type会覆盖后加载，为了数组覆盖顺序，倒叙插入
            createScriptUrlElements(scriptUrl.reverse());
        }
        else {
            createScriptUrlElements([scriptUrl]);
        }
    }
}
export default loadIcons;
